export const isCustomEvent = (evt: Event): evt is CustomEvent =>
	(evt as CustomEvent).detail !== undefined;
